import ListAgroExporters from "@/views/customer/reporting/process/ListAgroExporters.vue";
import ListProcesses from "@/views/customer/reporting/process/ListProcesses.vue";
import ListReports from "@/views/customer/reporting/process/ListReports.vue";
import ShowReport from "@/views/customer/reporting/process/ShowReport.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "customer",
  role: "reporting",
  permission: "process",
});

export default [
  {
    path: "/customer/:customer_id/reporting/process/list_agro_exporters",
    name: routeName("list_agro_exporters"),
    component: ListAgroExporters,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/reporting/process/:agro_exporter_id/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/reporting/process/:agro_exporter_id/list_reports/:agro_exporter_process_id",
    name: routeName("list_reports"),
    component: ListReports,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/reporting/process/:agro_exporter_id/show_report/:agro_exporter_process_id/:customer_report_id",
    name: routeName("show_report"),
    component: ShowReport,
    props: true,
    meta: META
  }
];
